import { createSelector } from "reselect";
import { uninitState, idleState } from "@grandvisionhq/state";
import { isUninitialized as isUninitialized$1, isLoggedIn as isLoggedIn$1, AuthState } from "./state.js";
const getAuth = (state) => state.auth;
const getAuthType = createSelector(getAuth, (auth) => auth.type);
const getDisableAddressEditing = createSelector(
  getAuth,
  (auth) => auth.disableAddressEditing
);
const isInitialized = createSelector(
  getAuth,
  (auth) => auth && !isUninitialized$1(auth)
);
const isUninitialized = createSelector(
  getAuth,
  (auth) => isUninitialized$1(auth)
);
const isLoggedIn = createSelector(
  getAuth,
  (auth) => auth && auth.state === AuthState.LoggedIn
);
const isLoggedOut = createSelector(
  getAuth,
  (auth) => auth && auth.state === AuthState.LoggedOut
);
const getRouting = createSelector(
  getAuth,
  (auth) => isUninitialized$1(auth) ? void 0 : auth.routing
);
const getRoutes = createSelector(
  getRouting,
  (routing) => routing ? routing.routes : void 0
);
const getBasePath = createSelector(
  getRouting,
  (routing) => routing ? routing.basePath : void 0
);
const getCheckoutRoute = createSelector(
  getRouting,
  (routing) => routing ? routing.checkoutRoute : void 0
);
const getFormattedRoutes = createSelector(
  getRoutes,
  getBasePath,
  (routes, basePath) => {
    if (!routes || !basePath) {
      return void 0;
    }
    return Object.entries(routes).reduce(
      (formattedRoutes, [name, route]) => ({
        [name]: `/${basePath}/${route}`,
        ...formattedRoutes
      }),
      {}
    );
  }
);
const getDomain = createSelector(
  isInitialized,
  getAuth,
  (isInitialized2, auth) => isInitialized2 ? auth.domain : void 0
);
const getCustomDomain = createSelector(
  isInitialized,
  getAuth,
  (isInitialized2, auth) => isInitialized2 ? auth.customDomain : void 0
);
const getUserId = createSelector(
  getAuth,
  (auth) => isLoggedIn$1(auth) ? auth.userId : void 0
);
const getOptIns = createSelector(
  getAuth,
  (auth) => !isUninitialized$1(auth) ? auth.optIns : []
);
const getOptInsForSignup = createSelector(
  getOptIns,
  (optIns) => optIns.filter((o) => o.isInSignup)
);
const getUserSettings = createSelector(
  getAuth,
  (auth) => isLoggedIn$1(auth) ? auth.userSettings : void 0
);
const getChangedOptIns = createSelector(
  getUserSettings,
  (userSettings) => userSettings ? userSettings.optInsState.changedOptIns : {}
);
const getOptInsOnServer = createSelector(
  getUserSettings,
  (userSettings) => userSettings ? userSettings?.optInsState.optInsOnServer : uninitState()
);
const getUpdateOptInsCall = createSelector(
  getUserSettings,
  (userSettings) => userSettings ? userSettings.optInsState.updateOptInsCall : idleState()
);
const getUserDataState = createSelector(
  getUserSettings,
  (userSettings) => userSettings?.userDataState
);
const getUserData = createSelector(
  getUserDataState,
  (userDataState) => userDataState?.userData
);
const getCallStatus = createSelector(
  getUserDataState,
  (userDataState) => userDataState?.updateCalls
);
const getSupportFeaturesLinks = createSelector(
  getAuth,
  (auth) => auth.supportFeaturesLinks
);
export {
  getAuth,
  getAuthType,
  getBasePath,
  getCallStatus,
  getChangedOptIns,
  getCheckoutRoute,
  getCustomDomain,
  getDisableAddressEditing,
  getDomain,
  getFormattedRoutes,
  getOptIns,
  getOptInsForSignup,
  getOptInsOnServer,
  getRoutes,
  getRouting,
  getSupportFeaturesLinks,
  getUpdateOptInsCall,
  getUserData,
  getUserDataState,
  getUserId,
  getUserSettings,
  isInitialized,
  isLoggedIn,
  isLoggedOut,
  isUninitialized
};
//# sourceMappingURL=selectors.js.map
